import { ApiResourceMethod } from '@/api/api-requests-factory';
import { CashierConfig } from '@/models/cashier-settings/cashier-settings.model';

export default class UpdateCashierConfig extends ApiResourceMethod<CashierConfig> {
  public perform(url: string, config: CashierConfig) {
    return this.performer.request({ url, data: config });
  }
}
